import React from 'react';
import { ArrowLeft, Edit, Trash2 } from 'lucide-react';
import { FracasIncident } from '../../types/fracas.types';
import { getSeverityColor, getStatusColor } from '../../utils/fracasHelpers';

interface FracasDetailHeaderProps {
    incident: FracasIncident;
    onBack: () => void;
    onEdit: () => void;
    onDelete: () => void;
    isEditing: boolean;
}

export const FracasDetailHeader: React.FC<FracasDetailHeaderProps> = ({
    incident,
    onBack,
    onEdit,
    onDelete,
    isEditing
}) => {
    return (
        <div className="mb-6">
            <button
                onClick={onBack}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
            >
                <ArrowLeft className="w-4 h-4" />
                Back to FRACAS List
            </button>

            <div className="flex items-center justify-between">
                <div>
                    <div className="flex items-center gap-4 mb-2">
                        <h1 className="text-3xl font-bold text-gray-900">
                            {incident.fracasNumber}
                        </h1>
                        <span
                            className={`px-3 py-1 rounded-full text-sm font-medium border ${getSeverityColor(
                                incident.severity
                            )}`}
                        >
                            {incident.severity}
                        </span>
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(incident.status)}`}>
                            {incident.status}
                        </span>
                    </div>
                    <h2 className="text-xl text-gray-700">{incident.title}</h2>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        onClick={onEdit}
                        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        <Edit className="w-4 h-4" />
                        {isEditing ? 'Cancel Edit' : 'Edit'}
                    </button>
                    <button
                        onClick={onDelete}
                        className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                    >
                        <Trash2 className="w-4 h-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};
